<script>
import FilterWorker from './filter.worker.js?worker'
import { toWorkerData } from './worker-data'

export default {
    data() {
        return {
            filteredDataIds: null,
            filterWorker: null,
        }
    },
    watch: {
        filters: {
            handler() {
                this.performFiltering()
            },
            deep: true
        },
        data() {
            this.populateWorkerData()
        },
    },
    created() {
        this.filterWorker = new FilterWorker()
        this.filterWorker.addEventListener('message', (m) => {
            if (m.data.action == 'filter') {
                this.filteredDataIds = m.data.result
            }
        })
        this.populateWorkerData()
    },
    unmounted() {
        if (this.filterWorker) {
            this.filterWorker.terminate()
            this.filterWorker = null
        }
    },
    computed: {
        filteredData() {
            if (this.filteredDataIds) {
                // Iterate over sections (synchronous, authoritative props) rather than
                // filteredDataIds, which is an async worker result that can be stale relative
                // to data/sections (e.g. data reshaped to fewer sections before the worker
                // catches up). Mirrors the robust pattern in displayData(). new Set(undefined)
                // yields an empty set, so a stale-shorter filteredDataIds is handled gracefully.
                const result = []
                this.sections.forEach((section, sectionIdx) => {
                    const sectionIds = new Set(this.filteredDataIds[sectionIdx])
                    result[sectionIdx] = this.data[sectionIdx].filter(r => sectionIds.has(r.id))
                })
                return result
            }
            return this.data
        },
    },
    methods: {
        populateWorkerData() {
            // turn Vue 3 Proxy object into raw object before sending to worker via postMessage.
            // toWorkerData() first strips each row down to the fields the worker reads, so the
            // serialize doesn't walk the full document/employee/company payload on every row.
            const headers = this.headers ? JSON.parse(JSON.stringify(this.headers)) : [] // May contain methods
            const sections = this.sections ? JSON.parse(JSON.stringify(this.sections)) : []
            const data = this.data ? JSON.parse(JSON.stringify(toWorkerData(this.data))) : {}
            const managers = this.managers ? JSON.parse(JSON.stringify(this.managers)) : {}
            this.filterWorker.postMessage({
                action: 'create',
                headers: headers,
                sections: sections,
                data: data,
                managers: managers,
            })
        },
        performFiltering() {
            if (this.filters && this.filters.length) {
                const filters = JSON.parse(JSON.stringify(this.filters))
                this.filterWorker.postMessage({
                    action: 'filter',
                    filters: filters,
                })
            }
            else {
                this.filteredDataIds = null
            }
        },
    },
}
</script>
